import { SelectChangeEvent, Stack } from '@mui/material';
import { Select, Typography } from 'fbm-ui';

import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { formatDeviceLabel } from './helpers';
import { roomActions } from './slice';
import { useTranslation } from 'react-i18next';

const SpeakerSelector = ({ width = 260, layoutAuto = false }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const speakersInfo = useAppSelector((state) => state.room.speakersInfo);
  const selectedSpeakerId = useAppSelector(
    (state) => state.room.selectedSpeakerId
  );

  const options = speakersInfo.map((option) => ({
    label: formatDeviceLabel(option.label, option.deviceId === 'default'),
    value: option.deviceId,
  }));
  const handleChange = (event: SelectChangeEvent<unknown>) => {
    const deviceId = event.target.value;
    dispatch(roomActions.setSelectedSpeakerId(deviceId));
  };

  if (speakersInfo.length > 1) {
    return (
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        width={1}
        spacing={1}
      >
        <Typography variant="body2" sx={{ width: layoutAuto ? 'auto' : 84 }}>
          {t('Speaker Test')}
        </Typography>
        <Select
          size="small"
          value={selectedSpeakerId}
          options={options}
          onChange={handleChange}
          sx={{
            width: layoutAuto ? 'auto' : width,
            flexGrow: layoutAuto ? 1 : 0,
          }}
        />
      </Stack>
    );
  }

  return null;
};

export default SpeakerSelector;
